import { Box } from "@mui/material";
import { EmbedHTMLAttributes } from "react";

type EmbedProps = EmbedHTMLAttributes<any>;

export const Embed = ({
  src,
  width = "810px",
  height = "810px",
  type = "application/pdf",
}: EmbedProps) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <embed
      data-testid="embed"
      src={src + "#toolbar=0&navpanes=0&scrollbar=0view=fit"}
      width={width}
      height={height}
      type={type}
    />
  </Box>
);
